@if (tooltip && !showAsTooltip) {
  <button
    type="button"
    (click)="openTooltip()"
    class="btn p-0 m-0 border-0 btn-sm {{ whiteIcon ? 'text-white' : 'text-dark-blue' }}"
    >
    <i class="far {{ smallIcon ? '' : 'fa-lg' }} fa-question-circle pointer"></i>
    <span class="sr-only">{{ title }} additional information</span>
  </button>
}

@if (tooltip && showAsTooltip) {
  <i
    class="{{ whiteIcon ? 'text-white' : 'text-dark-blue' }} far {{ smallIcon ? '' : 'fa-lg' }} fa-question-circle pointer"
    [ngbTooltip]="tooltip"
    tooltipClass="customTooltip"
    [autoClose]="'outside'"
    triggers="click"
  ></i>
  <span class="sr-only">{{ title }} additional information</span>
}
